import { Controller } from '@hotwired/stimulus';
import Macy from 'macy';

export default class extends Controller {

    static get targets() {
        return ['list', 'filter'];
    }

    connect() {
        const additionalOptions = this.element.dataset.masonry ? JSON.parse(this.element.dataset.masonry) : {};
        const list = this.targets.find('list');
        this.masonry = Macy({
            container: list,
            ... additionalOptions,
        });

        const filters = this.targets.findAll('filter');
        if (filters) {
            filters.forEach((filter) => {
                filter.addEventListener('click', (e) => {
                    e.preventDefault();

                    filters.forEach((f) => f.classList.remove('active'));
                    filter.classList.add('active');

                    if (filter.dataset.value !== 'all') {
                        list.querySelectorAll('.masonry-gallery-item').forEach((item) => {
                            item.style.display = 'none';
                        });

                        list.querySelectorAll(`.masonry-gallery-group-${filter.dataset.value}`).forEach((item) => {
                            item.style.display = 'block';
                        });
                        this.masonry.recalculate(true, true);
                    } else {
                        list.querySelectorAll('.masonry-gallery-item').forEach((item) => {
                            item.style.display = '';
                        });
                        this.masonry.recalculate(true, true);
                    }
                });
            });
        }

        this.targets.find('list').querySelectorAll('img').forEach((img) => {
            if (img.complete) {
                this.masonry.recalculate(true, true);
            }
            img.addEventListener('load', () => {
                this.masonry.recalculate(true, true);
            });
        });
    }
}
